<template>
  <div v-if="crumbs.length > 0">
    <nav
      aria-label="Breadcrumb"
      class="flex min-w-0 items-center gap-1.5"
      :class="unified ? 'h-4' : 'min-h-8 text-sm text-gray-600'"
    >
      <template v-for="(crumb, index) in crumbs" :key="index">
        <span v-if="index > 0" aria-hidden="true" class="shrink-0 text-gray-400"
          >/</span
        >
        <RouterLink
          v-if="crumb.to"
          v-tooltip="crumb.tooltip"
          :to="crumb.to"
          :title="unified ? crumb.label : undefined"
          aria-current-value="false"
          class="flex items-center gap-1 hover:text-burgundy-900"
          :class="
            unified || index === crumbs.length - 1 ? 'min-w-0' : 'shrink-0'
          "
        >
          <Icon v-if="crumb.icon" :name="crumb.icon" class="size-3 shrink-0" />
          <span
            :class="
              unified || index === crumbs.length - 1
                ? 'truncate'
                : 'whitespace-nowrap'
            "
            >{{ crumb.label }}</span
          >
        </RouterLink>
        <span
          v-else
          v-tooltip="crumb.tooltip"
          :aria-current="index === crumbs.length - 1 ? 'page' : undefined"
          class="min-w-0 truncate font-medium text-gray-800"
        >
          <slot v-if="index === crumbs.length - 1" name="last-crumb">
            {{ crumb.label }}
          </slot>
          <template v-else>{{ crumb.label }}</template>
        </span>
      </template>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { PropType } from "vue";
import type { RouteLocationRaw } from "vue-router";
import type { IconName } from "@/services/icons";
import Icon from "@/components/Core/Icon.vue";

defineProps({
  crumbs: { type: Array as PropType<BreadcrumbItem[]>, required: true },
  unified: { type: Boolean, default: false },
});
export interface BreadcrumbItem {
  label: string;
  to?: RouteLocationRaw;
  tooltip?: string;
  icon?: IconName;
}
</script>
